export const normalizeExternalUrl = (url: string): string => {
	const trimmed = url.trim()
	if (!trimmed) return trimmed
	if (/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(trimmed)) return trimmed
	if (trimmed.startsWith('//')) return `https:${trimmed}`
	return `https://${trimmed}`
}
